import { PrinterItem } from './Products/productFilter';

const recommendPrinterPlans = (
  printerList: PrinterItem[],
  currentPagesPerMonth: number
): PrinterItem[] => {
  return printerList.map((printer) => {
    let recommendedIndex = -1;

    // Sort ink plans by pagesPerMonth (ascending)
    const sortedPlans = printer.inkPlan
      .map((plan, idx) => ({ ...plan, idx }))
      .sort((a, b) => a.pagesPerMonth - b.pagesPerMonth);

    // Find exact match
    recommendedIndex = sortedPlans.findIndex(
      (plan) => plan.pagesPerMonth === currentPagesPerMonth
    );

    // If no exact match, find next higher
    if (recommendedIndex === -1) {
      recommendedIndex = sortedPlans.findIndex(
        (plan) => plan.pagesPerMonth > currentPagesPerMonth
      );
    }

    // If still not found, use next lower
    if (recommendedIndex === -1 && sortedPlans.length > 0) {
      recommendedIndex = sortedPlans.length - 1;
    }

    return {
      ...printer,
      inkPlan: printer.inkPlan
        .map((plan, idx) => ({
          ...plan,
          recommendedPlan: idx === sortedPlans?.[recommendedIndex]?.idx
        }))
        .sort((a, b) => a.pagesPerMonth - b.pagesPerMonth)
    };
  });
};

export default recommendPrinterPlans;
